import { useMutation } from "@tanstack/react-query";
import { attemptSetPassword } from '../../api/AuthApi';

export const useSetPassword = () => {
  return useMutation({
    mutationKey: 'set-password',
    mutationFn: async (data) => attemptSetPassword(data),
  });
};